import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {getTableColumns, getTableData} from "../../models/recurringExpenseModel";
import ActionDropdown from "../../components/actions/ActionDropdown";
import Table from "../../components/common/table/Table";
import {
    deleteRecurringExpense,
    fetchAllRecurringExpense,
    resetCreateStatus,
    resetUpdateStatus
} from "../../store/recurring-expense-slice";
import {fetchNotApplicableList} from "../../store/list-slice";

const RecurringExpenseView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        error,
        pagination
    } = useSelector(state => state.recurringExpense); // Updated to customer slice

    const list = useSelector(state => state.list);
    const userRole = useSelector((state) => state.auth.selectedRole);

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchAllRecurringExpense({
            ...userRole,
            page: initialPage,
            limit: initialLimit
        }));
    }, [dispatch, userRole, initialPage, initialLimit]);

    useEffect(() => {
        dispatch(fetchNotApplicableList())
    }, [dispatch]);

    useEffect(() => {
        if (updateStatus === "success") dispatch(resetUpdateStatus());
        if (createStatus === "success") dispatch(resetCreateStatus());
    }, [dispatch, updateStatus, createStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteRecurringExpense({...userRole, id})); // Updated action
    };

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler});
    const tableData = getTableData({items, list});

    return (
        <>
            <SubHeader title="All Recurring Expense">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                    pagination={pagination}
                />
            )}
        </>
    );
}

export default RecurringExpenseView;